import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '~src/modules/result/Home.vue'

const routes: RouteRecordRaw[] = [
  { path: '/', component: Home },
]

const router = createRouter({ history: createWebHistory(), routes })

export default router
